import { ref } from 'vue';
import { defineStore } from 'pinia';

export const useSdkStatusStore = defineStore('sdkStatusStore', () => {
    const changeFeeds = ref({});

    function updateChangeFeedInfo(changeFeedName, newInfo) {
        changeFeeds.value[changeFeedName] = newInfo;
    }

    function getChangeFeedInfo(changeFeedName) {
        return changeFeeds.value[changeFeedName];
    }

    return {
        changeFeeds,
        updateChangeFeedInfo,
        getChangeFeedInfo
    }
})

/*
changeFeeds {
    'event-activity': {
        status: 'RECONNECTING', //INITIALIZING, CONNECTED, DISCONNECTED
        attempt: 4
    },
    'item-bidding': {
        status: 'CONNECTED',
        attempt: 4
    }
}
*/